import { ThreeViewBase, Scene, events, defines, Cameras, matUtils } from "./index";
import * as THREE from "three";

export enum MessageType {
    Alert,
    Warning,
    Note,
}
/**
 * class: ItemManager
 */
export class ItemManager {

    private _scene: Scene;

    private _meshs: any[];
    private _lines: any[];
    private _hitMeshs: any[];

    private _message: THREE.Group;
    private _messageShown: boolean;

    public get scene(): Scene { return this._scene; }
    public get meshs(): any[] { return this._meshs; }
    public get lines(): any[] { return this._lines; }
    public get hitMeshs(): any[] { return this._hitMeshs; }
    public get message(): any { return this._message; }
    public get messageShown(): boolean { return this._messageShown; }

    private _eventDispatcher: events.EventDispatcher;
    public get eventDispatcher() { return this._eventDispatcher; }

    /*
     * コンストラクタ.
     */
    constructor(scene: Scene, eventDispatcher?: events.EventDispatcher) {
        this._scene = scene;
        this._eventDispatcher = eventDispatcher;
        this.reset(new defines.Options);
    }

    /* reset
     * データのリセット.
     */
    public reset(options: defines.Options): void {
        this._meshs = [];
        this._lines = [];
        this._hitMeshs = [];

        if ((this.message != undefined) && (this.scene != undefined))
            this.scene.remove(this.message);
        this._message = new THREE.Group;
        this._messageShown = false;

        this.registerItems();
    }

    /* update
     * 描画前のアップデート.
     */
    public update(cameras: Cameras, timeStamp: number) {
        /* do nothing */
    }

    /* registerScene
     * シーン内のデフォルトアイテムの再登録.
     */
    public registerItems(): void {
        if (this.scene.environment.ground != undefined)
            this.meshs.push(this.scene.environment.ground.mesh);
    }

    /* createMessage
     * メッセージボードを用意する.
     */
    public createMessage(type: MessageType, messages: string[], subtexts: string[]): void {
        var texture = matUtils.createMessageTexture(type, messages, subtexts, function (texture: any) {
            // 物体を作成し、シーンに追加
            let geoPlate: THREE.BoxGeometry = new THREE.BoxGeometry(6, 3, 0.2);
            let matPlate: THREE.MeshLambertMaterial = new THREE.MeshLambertMaterial(
                {
                    color: 0xaaaaaa,
                    map: texture
                });
            let meshPlate: THREE.Mesh = new THREE.Mesh(geoPlate, matPlate);
            meshPlate.position.x -= 4.8; // added.
            meshPlate.position.y += 2.7;
            meshPlate.position.z += 10.5; //5.0;
            meshPlate.rotation.z = Math.PI / 90;
            THREE.ImageUtils.crossOrigin = "*";
            const texLoader = new THREE.TextureLoader();
            texLoader.crossOrigin = '';
            let texPole = texLoader.load(defines.TextureDefs.messageBoardTexPath);
            //let texPole = THREE.ImageUtils.loadTexture(defines.TextureDefs.messageBoardTexPath, null, function (img) { });
            let geoPole: THREE.BoxGeometry = new THREE.BoxGeometry(0.2, 6.2, 0.2);
            let matPole: THREE.MeshLambertMaterial = new THREE.MeshLambertMaterial(
                {
                    color: 0xaaaaaa,
                    map: texPole
                });
            let meshPole1: THREE.Mesh = new THREE.Mesh(geoPole, matPole);
            meshPole1.position.x -= 7.0; //2.2;
            meshPole1.position.z += 10.3; //4.8;
            meshPole1.rotation.z = -Math.PI / 100;
            let meshPole2: THREE.Mesh = meshPole1.clone();
            meshPole2.position.x += 4.4;
            meshPole2.rotation.z = Math.PI / 90;

            ThreeViewBase.get().itemmgr.message.add(meshPlate);
            ThreeViewBase.get().itemmgr.message.add(meshPole1);
            ThreeViewBase.get().itemmgr.message.add(meshPole2);

        }, defines.TextureDefs.messageBoardTexPath);
    }

    /* showMessage
     * メッセージボードを表示する.
     */
    public showMessage(): void {
        ThreeViewBase.get().scene.add(ThreeViewBase.get().itemmgr.message);
        this._messageShown = true;
    }
    /* hideMessage
     * メッセージボードを隠す.
     */
    public hideMessage(): void {
        ThreeViewBase.get().scene.remove(ThreeViewBase.get().itemmgr.message);
        this._messageShown = false;
    }
}

